exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1iMnr{width:250px;padding:0 0 10px;cursor:pointer}._20-nl{padding:0 5px 10px}._3rzxl{opacity:0}._1oXxa,._2hH1E{height:217px}._1oXxa{margin-right:5%;position:relative;left:0;top:0;-webkit-box-flex:0;-ms-flex:0 0 340px;flex:0 0 340px;width:240px}._1Xi9Q{display:block;color:#fff;font-size:15px;max-height:45px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;padding:0 5px}._1oXxa,._2hH1E{position:relative;background:#f1f1f1 no-repeat 50%/cover}._1mXiS{background-size:60%}@media screen and (max-width:768px){._1oXxa{-webkit-box-flex:0;-ms-flex:0 0 180px;flex:0 0 180px}}@media screen and (max-width:400px){._1oXxa{-webkit-box-flex:0;-ms-flex:0 0 145px;flex:0 0 145px}}", ""]);

// exports
exports.locals = {
	"root": "_1iMnr",
	"mobileRoot": "_20-nl",
	"stretchedLink": "_3rzxl stretched",
	"tableThumb": "_2hH1E",
	"listThumb": "_1oXxa",
	"tableDate": "_1Xi9Q",
	"placeholderThumb": "_1mXiS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/VideosItem/VideosItem.css
// module id = 3287
// module chunks = 32